module.exports = __webpack_public_path__ + "static/media/poll.93bb9cb7.svg";